import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  resetSbatGroupBulkUpdate,
  selectedBulkUpdateSbatGroupsSelector,
  setBulkSelectedSbatGroups,
} from 'features/classCreation';
import CheckboxInput from 'components/CheckboxInput';

export default function SelectAllUpcomingSbatGroupsButton({ sbatGroups }) {
  const dispatch = useDispatch();
  const selectedSbatGroups = useSelector(selectedBulkUpdateSbatGroupsSelector);
  const allSbatGroupsSelected =
    Object.keys(selectedSbatGroups).length === sbatGroups.length;

  const handleSelectAll = useCallback(
    ({ target }) => {
      const { checked } = target;

      dispatch(resetSbatGroupBulkUpdate());
      if (checked) {
        const selectedSbatGroupsObj = {};
        sbatGroups.forEach((sbatGroup) => {
          selectedSbatGroupsObj[sbatGroup.id] = { ...sbatGroup };
        });
        dispatch(setBulkSelectedSbatGroups(selectedSbatGroupsObj));
      }
    },
    [dispatch, sbatGroups]
  );

  return (
    <>
      <CheckboxInput
        onChange={handleSelectAll}
        checked={allSbatGroupsSelected}
        className="m-l-xxs"
      />
      <span className="mr-xxs">Select All</span>
    </>
  );
}
